import "./DropdownMenuItem.scss";

export const DropdownMenuDivider = () => {
  return <li className="dropdown-menu-item__divider" />;
};
